import React from 'react';
import { Link } from 'react-router-dom';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-taupe-border/80 pt-16 pb-12 text-espresso">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          {/* Col 1: Brand & Bio */}
          <div className="space-y-4">
            <Link to="/" className="inline-block group focus:outline-hidden">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=360,quality=90,format=auto/assets/bbc8c269-a12e-46e2-947b-0cefa0025eea/cryo-by-breum-logo.png"
                alt="CRYO BY BREUM logo - Klinik for kropsbehandlinger og træning i Odense"
                className="h-7 w-auto object-contain"
              />
            </Link>
            <div className="pt-2">
              <a
                href={BOOKING_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-brown text-white text-xs tracking-widest uppercase font-semibold hover:bg-accent-brown-hover transition-colors shadow-xs"
              >
                <span>Book behandling</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>
          </div>

          {/* Col 2: Behandlinger */}
          <div>
            <h3 className="font-sans text-xs font-semibold text-espresso mb-4 uppercase tracking-widest">
              Behandlinger
            </h3>
            <ul className="space-y-2.5 text-sm text-espresso-light">
              <li>
                <Link to="/behandlinger/fedtfrysning" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Fedtfrysning
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/ems-traening" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  EMS Træning
                </Link>
              </li>
              <li>
                <Link to="/behandlinger/body-roll" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Body Roll
                </Link>
              </li>
              <li>
                <Link to="/priser" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Priser & Klippekort
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Genveje */}
          <div>
            <h3 className="font-sans text-xs font-semibold text-espresso mb-4 uppercase tracking-widest">
              Genveje
            </h3>
            <ul className="space-y-2.5 text-sm text-espresso-light">
              <li>
                <Link to="/" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/om-cryo-by-breum" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Om Cryo by Breum
                </Link>
              </li>
              <li>
                <Link to="/priser" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Prisoversigt
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-espresso transition-colors hover:underline underline-offset-4">
                  Kontakt & Find vej
                </Link>
              </li>
              <li>
                <a 
                  href={BOOKING_URL} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-espresso transition-colors inline-flex items-center gap-1.5"
                >
                  <span>Planway Online Booking</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-taupe" aria-hidden="true" />
                </a>
              </li>
            </ul>
          </div>

          {/* Col 4: Kontakt & Adresse */}
          <div>
            <h3 className="font-sans text-xs font-semibold text-espresso mb-4 uppercase tracking-widest">
              Klinikken
            </h3>
            <div className="space-y-3 text-sm text-taupe">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot mt-1 text-espresso/70 text-xs" aria-hidden="true" />
                <div>
                  <p className="font-medium text-espresso">Cryo by Breum</p>
                  <p>Dalumvej 82</p>
                  <p>5250 Odense SV</p>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-1">
                <i className="fa-solid fa-phone text-espresso/70 text-xs" aria-hidden="true" />
                <a 
                  href="tel:+4526434402" 
                  className="text-espresso font-medium hover:text-accent-brown transition-colors whitespace-nowrap"
                >
                  26 43 44 02
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-taupe-border flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-taupe">
          <p>© {currentYear} Cryo by Breum. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-2">
            <span>Dalumvej 82, 5250 Odense SV</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
